"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _client = _interopRequireDefault(require("react-dom/client"));
var _content = _interopRequireDefault(require("./content"));
var _excluded = ["component", "html"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/Modal/dialog.js";
function Dialog() {
  this.close = function () {
    var node = this.nodes.pop();
    node && this.root.unmount();
    node && node.remove();
    this.nodes.length === 0 && document.body.classList.remove('modal-open');
  };
  // html is deprecated
  this.fire = function (_ref) {
    var component = _ref.component,
      html = _ref.html,
      pros = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
    this.nodes = this.nodes || [];
    var node = document.createElement("div");
    node.setAttribute("tabindex", "-1");
    node.style.position = "relative";
    document.body.appendChild(node);
    this.nodes.push(node);
    this.root = _client["default"].createRoot(node);
    this.root.render( /*#__PURE__*/_react["default"].createElement(_content["default"], Object.assign({
      isOpen: true,
      onClosed: this.close.bind(this)
    }, pros, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 22,
        columnNumber: 13
      }
    }), component || html));
  };
}
var _default = new Dialog();
exports["default"] = _default;